// Un carrousel Splide monté dans un panneau replié (collapse fermé) démarre à largeur
// nulle. À l'ouverture du panneau, on déclenche un resize pour que Splide recalcule ses
// dimensions. Monté sur le conteneur d'accordéon via is="splide-collapse-refresh".
export class SplideCollapseRefresh extends HTMLDivElement {

    connectedCallback() {
        this.addEventListener('shown.bs.collapse', this.onShown);
    }

    disconnectedCallback() {
        this.removeEventListener('shown.bs.collapse', this.onShown);
    }

    private onShown = () => {
        window.dispatchEvent(new Event('resize'));
    };
}
